import React from 'react';

import {CitySelection} from 'presentation/pages/private/city-selection';
import {LocationSelectionFlowEnum} from 'presentation/utils';

export const MakeCitySelection: React.FC<{
	flowType: LocationSelectionFlowEnum;
}> = ({flowType}) => <CitySelection flowType={flowType} />;
